import { render } from "./HeadIcon.vue?vue&type=template&id=064ebce7"
import script from "./HeadIcon.vue?vue&type=script&lang=js"
export * from "./HeadIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__